import { useCheckFeatureFlag } from './useFeatureFlags';
import { FeatureFlags } from './useFeatureFlags/types';

function useIsTrainingEnabled() {
  const checkFeatureFlag = useCheckFeatureFlag();

  return checkFeatureFlag(FeatureFlags.ORG_ENABLE_TRAINING);
}

export default useIsTrainingEnabled;
